import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import './assets/shared.css'

import axios from 'axios'

Vue.config.productionTip = false
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,HEAD,OPTIONS,POST,PUT';
//axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Content-Type, Authorization';
axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';
//axios.defaults.baseURL = 'http://13.90.245.203:85/' //Este es para respaldo y pruebas
axios.defaults.baseURL = 'https://www.lotterybestoneapi.online/' //Este es para respaldo y pruebas
//axios.defaults.baseURL = 'https://tiemposapi.azurewebsites.net/' //Este es el oficial
//axios.defaults.baseURL = 'http://localhost:54961/' este no
//axios.defaults.baseURL = 'https://localhost:7253/'


new Vue({
  router,
  store,
  vuetify,
  axios,
  render: function (h) { return h(App) }
}).$mount('#app')

